module.exports = __webpack_public_path__ + "static/media/masthead-manjimup-bridgetown-times.4bb337e0.svg";